 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { useEffect, useLayoutEffect, useRef} from 'react'


import useRefState from './useRefState'
import useResizeObserver from './useResizeObserver'

 










export var MenuPosition; (function (MenuPosition) {
  const UPPER_LEFT = 0; MenuPosition[MenuPosition["UPPER_LEFT"] = UPPER_LEFT] = "UPPER_LEFT";
  const UPPER_RIGHT = UPPER_LEFT + 1; MenuPosition[MenuPosition["UPPER_RIGHT"] = UPPER_RIGHT] = "UPPER_RIGHT";
  const UPPER_CENTER = UPPER_RIGHT + 1; MenuPosition[MenuPosition["UPPER_CENTER"] = UPPER_CENTER] = "UPPER_CENTER";
  const LOWER_LEFT = UPPER_CENTER + 1; MenuPosition[MenuPosition["LOWER_LEFT"] = LOWER_LEFT] = "LOWER_LEFT";
  const LOWER_RIGHT = LOWER_LEFT + 1; MenuPosition[MenuPosition["LOWER_RIGHT"] = LOWER_RIGHT] = "LOWER_RIGHT";
  const LOWER_CENTER = LOWER_RIGHT + 1; MenuPosition[MenuPosition["LOWER_CENTER"] = LOWER_CENTER] = "LOWER_CENTER";
})(MenuPosition || (MenuPosition = {}));

const getOffset = (
  orientation,
  fullWidth
) => {
  if (orientation === 'center') {
    return fullWidth / 2
  } else if (orientation === 'right' || orientation === 'bottom') {
    return fullWidth
  }
  return 0
}

const anchorLookup = {
  [MenuPosition.UPPER_LEFT]: {
    targetAnchor: {
      horizontal: 'left',
      vertical: 'top'
    },
    originAnchor: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  [MenuPosition.UPPER_RIGHT]: {
    targetAnchor: {
      horizontal: 'right',
      vertical: 'top'
    },
    originAnchor: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  },
  [MenuPosition.UPPER_CENTER]: {
    targetAnchor: {
      horizontal: 'center',
      vertical: 'top'
    },
    originAnchor: {
      horizontal: 'center',
      vertical: 'bottom'
    }
  },
  [MenuPosition.LOWER_LEFT]: {
    targetAnchor: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    originAnchor: {
      horizontal: 'left',
      vertical: 'top'
    }
  },
  [MenuPosition.LOWER_RIGHT]: {
    targetAnchor: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    originAnchor: {
      horizontal: 'right',
      vertical: 'top'
    }
  },
  [MenuPosition.LOWER_CENTER]: {
    targetAnchor: {
      horizontal: 'center',
      vertical: 'bottom'
    },
    originAnchor: {
      horizontal: 'center',
      vertical: 'top'
    }
  }
} 

const lowerLookup = {
  [MenuPosition.UPPER_LEFT]: MenuPosition.LOWER_LEFT,
  [MenuPosition.UPPER_RIGHT]: MenuPosition.LOWER_RIGHT
} 

const MENU_PADDING = 4

const getNextCoords = (targetBBox, originBBox, preferredMenuPosition) => {
  const {height: modalHeight, width: modalWidth} = targetBBox
  const {height: originHeight, width: originWidth, left: originLeft, top: originTop} = originBBox
  const {originAnchor, targetAnchor} = anchorLookup[preferredMenuPosition]
  const nextCoords = {} 

  const originLeftOffset = getOffset(originAnchor.horizontal, originWidth)
  const {scrollX, scrollY, innerHeight} = window
  // Do not use window.innerWidth because that does not account for the scrollbar width
  const pageWidth = document.documentElement.clientWidth
  if (targetAnchor.horizontal !== 'right') {
    const targetLeftOffset = getOffset(targetAnchor.horizontal, modalWidth)
    const left = scrollX + originLeft + originLeftOffset - targetLeftOffset
    const maxLeft = pageWidth - modalWidth + scrollX
    nextCoords.left = Math.min(left, maxLeft)
  } else {
    const right = pageWidth - (originLeft + originLeftOffset) - scrollX
    const maxRight = pageWidth - modalWidth - scrollX
    nextCoords.right = Math.min(right, maxRight)
  }

  if (targetAnchor.vertical !== 'bottom') {
    const originTopOffset = getOffset(originAnchor.vertical, originHeight)
    const targetTopOffset = getOffset(targetAnchor.vertical, modalHeight)
    const top = scrollY + originTop + originTopOffset - targetTopOffset
    const isBelow = top + modalHeight < innerHeight + scrollY
    if (isBelow) {
      nextCoords.top = top + MENU_PADDING
    }
  }
  const menuPosition =
    (nextCoords.top === undefined &&
      lowerLookup[preferredMenuPosition ]) ||
    preferredMenuPosition
  // if by choice or circumstance, put it above & anchor it from the bottom
  if (nextCoords.top === undefined) {
    const bottom = innerHeight - originTop - scrollY
    const maxBottom = innerHeight - modalHeight + scrollY
    nextCoords.bottom = Math.min(bottom, maxBottom) + MENU_PADDING
  }
  return {coords: nextCoords , menuPosition}
}






const useWindowResize = (
  coordsRef,
  currentTargetRef,
  setCoords
) => {
  useEffect(() => {
    const resizeWindow = () => {
      const {coords, menuPosition} = coordsRef.current
      if (currentTargetRef && ('right' in coords || 'bottom' in coords)) {
        const targetCoords = currentTargetRef.getBoundingClientRect()
        setCoords({
          coords: {
            left: targetCoords.left,
            top: targetCoords.top
          },
          menuPosition
        })
      }
    }
    window.addEventListener('resize', resizeWindow, {passive: true})
    return () => {
      window.removeEventListener('resize', resizeWindow)
    }
  }, [coordsRef, currentTargetRef, setCoords])
}

const useCoords = 


(
  preferredMenuPosition,
  options = {}
) => {
  const targetRef = useRef(null)
  const originRef = useRef(null)
  const [coordsRef, setCoords] = useRefState({
    coords: {left: 0, top: 0},
    menuPosition: preferredMenuPosition
  })
  useLayoutEffect(() => {
    if (!targetRef.current || !originRef.current) return
    // Bounding adjustments mimic native (flip from below to above for Y, but adjust pixel-by-pixel for X)
    const targetBBox = _optionalChain([targetRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.getBoundingClientRect, 'call', _3 => _3()])
    const originBBox = _optionalChain([originRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.getBoundingClientRect, 'call', _6 => _6()])
    if (targetBBox && originBBox) {
      const coordState = getNextCoords(targetBBox, originBBox, preferredMenuPosition)
      setCoords(coordState)
    }
  }, [
    targetRef.current,
    setCoords,
    options.originCoords,
    preferredMenuPosition,
    options.portalStatus
  ])

  useResizeObserver(() => {
    const targetBBox = _optionalChain([targetRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.getBoundingClientRect, 'call', _9 => _9()])
    const originBBox = _optionalChain([originRef, 'access', _10 => _10.current, 'optionalAccess', _11 => _11.getBoundingClientRect, 'call', _12 => _12()])
    if (targetBBox && originBBox) {
      const coordState = getNextCoords(targetBBox, originBBox, preferredMenuPosition)
      setCoords(coordState)
    }
  }, targetRef)

  useWindowResize(coordsRef, targetRef.current, setCoords)
  const {coords, menuPosition} = coordsRef.current

  return {targetRef, originRef, coords, menuPosition}
}

export default useCoords
